import { complement, isEmpty, isNil } from 'rambda'
import { _ } from '@feathersjs/commons'

const { isObject, isObjectOrArray } = _

export { isObject, isObjectOrArray }

// Type Casters
export const castArray = array => Array.isArray(array) ? array : [array]

// Type Checkers
export const isNumeric = value => typeof value === 'number' ||
  (typeof value === 'string' && !isNaN(value))

export const isError = value => isObject(value) &&
  (value instanceof Error || (value.code && value.name))

export const isDate = value => value instanceof Date && !isNaN(value.valueOf())

export const isNotNil = complement(isNil)

export const isNotEmpty = complement(isEmpty)
